export const DropItem = [
	{
		id: 1,
		ItemName: 'Recommand',
		value: 'Recommand',
	},
	{
		id: 2,
		ItemName: 'New Dish',
		value: 'New Dish',
	},
	{
		id: 3,
		ItemName: 'Popular',
		value: 'Popular',
	},
	{
		id: 4,
		ItemName: 'Top Rated',
		value: 'Top Rated',
	},
];
export const FilterItem = [
	{
		id: 1,
		value: 'All',
	},
	{
		id: 2,
		value: 'Veg',
	},
	{
		id: 3,
		value: 'Non-veg',
	},
	{
		id: 4,
		ItemName: 'Top Rated',
		value: 'Top Rated',
	},
];